import { Union } from "../fable_modules/fable-library.3.7.20/Types.js";
import { option_type, int32_type, union_type, string_type } from "../fable_modules/fable-library.3.7.20/Reflection.js";
import { Result_Map, FSharpResult$2, Result_Bind } from "../fable_modules/fable-library.3.7.20/Choice.js";
import { EmptyOrRange1To31Module_create, AlphaNumeric40Module_create, String32OrEmptyModule_create, String40Module_create, isPeppolId, isPositiveInteger, isValidEmail, isNotNullOrWhitespace, lengthGT, lengthEQ, isOnlyNumbers, isNotNullOrEmpty, InputType, lengthLTE, isAllowedAlphaNumeric } from "./Common.js";
import { luhnCheck, getIdNumberType } from "../Utils.js";
import { printf, toText } from "../fable_modules/fable-library.3.7.20/String.js";
import { parse } from "../fable_modules/fable-library.3.7.20/Int32.js";

export class City extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["City"];
    }
}

export function City$reflection() {
    return union_type("Validation.Invoicee.City", [], City, () => [[["Item", string_type]]]);
}

export function CityModule_create(getTranslation, str) {
    const _arg = Result_Bind((str_3) => isAllowedAlphaNumeric(getTranslation, str_3), Result_Bind((str_2) => lengthLTE(getTranslation, 25, new InputType(2), str_2), isNotNullOrEmpty(getTranslation, str)));
    if (_arg.tag === 1) {
        return new FSharpResult$2(1, _arg.fields[0]);
    }
    else {
        return new FSharpResult$2(0, new City(0, _arg.fields[0]));
    }
}

export function CityModule_value(_arg) {
    return _arg.fields[0];
}

export class ContactNumber extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ContactNumber"];
    }
}

export function ContactNumber$reflection() {
    return union_type("Validation.Invoicee.ContactNumber", [], ContactNumber, () => [[["Item", string_type]]]);
}

export function ContactNumberModule_create(getTranslation, str) {
    if ("" === str.trim()) {
        return new FSharpResult$2(0, new ContactNumber(0, str));
    }
    else {
        const _arg = Result_Bind((str_2) => isOnlyNumbers(getTranslation, str_2), lengthLTE(getTranslation, 18, new InputType(0), str));
        if (_arg.tag === 1) {
            return new FSharpResult$2(1, _arg.fields[0]);
        }
        else {
            return new FSharpResult$2(0, new ContactNumber(0, _arg.fields[0]));
        }
    }
}

export function ContactNumberModule_value(_arg) {
    return _arg.fields[0];
}

export class OrganisationNumber extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["OrganisationNumber"];
    }
}

export function OrganisationNumber$reflection() {
    return union_type("Validation.Invoicee.OrganisationNumber", [], OrganisationNumber, () => [[["Item", string_type]]]);
}

export function OrganisationNumberModule_value(_arg) {
    return _arg.fields[0];
}

export function OrganisationNumberModule_create(getTranslation, isoCountryCode, str) {
    const _arg = Result_Bind((value_1) => {
        let arg;
        const idNumberType = getIdNumberType(value_1, isoCountryCode);
        switch (idNumberType.tag) {
            case 1: {
                if (isoCountryCode.ThreeLetter === "SWE") {
                    const matchValue_2 = luhnCheck(value_1, isoCountryCode.ThreeLetter);
                    if (matchValue_2) {
                        return new FSharpResult$2(0, value_1);
                    }
                    else {
                        return new FSharpResult$2(1, "Luhn check failed.");
                    }
                }
                else {
                    return new FSharpResult$2(0, value_1);
                }
            }
            case 2: {
                return new FSharpResult$2(1, getTranslation("Validation.Empty"));
            }
            case 3: {
                let formatStr;
                const matchValue_3 = isoCountryCode.ThreeLetter;
                switch (matchValue_3) {
                    case "SWE": {
                        formatStr = "ååmmddnnnn | OrgNr: xxxxxxxxxx";
                        break;
                    }
                    case "NOR": {
                        formatStr = "ddmmåånnn | OrgNr: xxxxxxxxx";
                        break;
                    }
                    case "FIN": {
                        formatStr = "DDMMYYCZZZQ | OrgNr: xxxxxxx-x";
                        break;
                    }
                    case "DNK": {
                        formatStr = "DDMMYYSSSS | OrgNr: xxxxxxxx";
                        break;
                    }
                    default: {
                        formatStr = "";
                    }
                }
                return new FSharpResult$2(1, (arg = getTranslation("Validation.UnsupportedNumberFormat"), toText(printf("%s: %s"))(arg)(formatStr)));
            }
            default: {
                return new FSharpResult$2(0, value_1);
            }
        }
    }, Result_Bind((value) => {
        const matchValue = isoCountryCode.ThreeLetter;
        switch (matchValue) {
            case "SWE": {
                return lengthEQ(getTranslation, 10, new InputType(0), value);
            }
            case "NOR": {
                return Result_Bind((str_2) => lengthLTE(getTranslation, 11, new InputType(0), str_2), lengthGT(getTranslation, 7, new InputType(0), value));
            }
            case "FIN": {
                return Result_Bind((str_4) => lengthLTE(getTranslation, 11, new InputType(0), str_4), lengthGT(getTranslation, 7, new InputType(0), value));
            }
            case "DNK": {
                return Result_Bind((str_6) => lengthLTE(getTranslation, 11, new InputType(0), str_6), lengthGT(getTranslation, 7, new InputType(0), value));
            }
            default: {
                return Result_Bind((str_8) => lengthLTE(getTranslation, 11, new InputType(0), str_8), lengthGT(getTranslation, 8, new InputType(0), value));
            }
        }
    }, isNotNullOrWhitespace(getTranslation, str)));
    if (_arg.tag === 1) {
        return new FSharpResult$2(1, _arg.fields[0]);
    }
    else {
        return new FSharpResult$2(0, new OrganisationNumber(0, _arg.fields[0]));
    }
}

export class Email extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Email"];
    }
}

export function Email$reflection() {
    return union_type("Validation.Invoicee.Email", [], Email, () => [[["Item", string_type]]]);
}

export function EmailModule_create(getTranslation, str) {
    if ("" === str.trim()) {
        return new FSharpResult$2(0, new Email(0, str));
    }
    else {
        const _arg = Result_Bind((str_3) => isValidEmail(getTranslation, str_3), Result_Bind((str_2) => lengthLTE(getTranslation, 50, new InputType(2), str_2), lengthGT(getTranslation, 4, new InputType(2), str)));
        if (_arg.tag === 1) {
            return new FSharpResult$2(1, _arg.fields[0]);
        }
        else {
            return new FSharpResult$2(0, new Email(0, _arg.fields[0]));
        }
    }
}

export function EmailModule_createNonEmpty(getTranslation, str) {
    const _arg = Result_Bind((str_4) => isValidEmail(getTranslation, str_4), Result_Bind((str_3) => lengthLTE(getTranslation, 50, new InputType(2), str_3), Result_Bind((str_2) => lengthGT(getTranslation, 4, new InputType(2), str_2), isNotNullOrEmpty(getTranslation, str))));
    if (_arg.tag === 1) {
        return new FSharpResult$2(1, _arg.fields[0]);
    }
    else {
        return new FSharpResult$2(0, new Email(0, _arg.fields[0]));
    }
}

export function EmailModule_value(_arg) {
    return _arg.fields[0];
}

export class PostalAttention extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["PostalAttention"];
    }
}

export function PostalAttention$reflection() {
    return union_type("Validation.Invoicee.PostalAttention", [], PostalAttention, () => [[["Item", string_type]]]);
}

export function PostalAttentionModule_create(getTranslation, str) {
    const _arg = lengthLTE(getTranslation, 40, new InputType(2), str);
    if (_arg.tag === 1) {
        return new FSharpResult$2(1, _arg.fields[0]);
    }
    else {
        return new FSharpResult$2(0, new PostalAttention(0, _arg.fields[0]));
    }
}

export function PostalAttentionModule_value(_arg) {
    return _arg.fields[0];
}

export class CustomerGroupCode extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["CustomerGroupCode"];
    }
}

export function CustomerGroupCode$reflection() {
    return union_type("Validation.Invoicee.CustomerGroupCode", [], CustomerGroupCode, () => [[["Item", option_type(int32_type)]]]);
}

export function CustomerGroupCodeModule_create(getTranslation, str) {
    if (str === "") {
        return new FSharpResult$2(0, new CustomerGroupCode(0, void 0));
    }
    else {
        const _arg = Result_Map((value) => parse(value, 511, false, 32), isPositiveInteger(getTranslation, str));
        if (_arg.tag === 1) {
            return new FSharpResult$2(1, _arg.fields[0]);
        }
        else {
            return new FSharpResult$2(0, new CustomerGroupCode(0, _arg.fields[0]));
        }
    }
}

export function CustomerGroupCodeModule_value(_arg) {
    return _arg.fields[0];
}

export class PeppolId extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["PeppolId"];
    }
}

export function PeppolId$reflection() {
    return union_type("Validation.Invoicee.PeppolId", [], PeppolId, () => [[["Item", option_type(string_type)]]]);
}

export function PeppolIdModule_create(getTranslation, str) {
    if (str === "") {
        return new FSharpResult$2(0, new PeppolId(0, void 0));
    }
    else {
        const _arg = Result_Bind((str_2) => isPeppolId(getTranslation, str_2), lengthLTE(getTranslation, 55, new InputType(2), str));
        if (_arg.tag === 1) {
            return new FSharpResult$2(1, _arg.fields[0]);
        }
        else {
            return new FSharpResult$2(0, new PeppolId(0, _arg.fields[0]));
        }
    }
}

export function PeppolIdModule_createNonEmpty(getTranslation, str) {
    const _arg = Result_Bind((str_3) => isPeppolId(getTranslation, str_3), Result_Bind((str_2) => lengthLTE(getTranslation, 55, new InputType(2), str_2), isNotNullOrWhitespace(getTranslation, str)));
    if (_arg.tag === 1) {
        return new FSharpResult$2(1, _arg.fields[0]);
    }
    else {
        return new FSharpResult$2(0, new PeppolId(0, _arg.fields[0]));
    }
}

export function PeppolIdModule_value(_arg) {
    return _arg.fields[0];
}

export class ZipCode extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ZipCode"];
    }
}

export function ZipCode$reflection() {
    return union_type("Validation.Invoicee.ZipCode", [], ZipCode, () => [[["Item", string_type]]]);
}

export function ZipCodeModule_create(getTranslation, threeLetterCountryCode, str) {
    const _arg = Result_Bind((value) => {
        switch (threeLetterCountryCode) {
            case "SWE": {
                return lengthEQ(getTranslation, 5, new InputType(0), value);
            }
            case "NOR": {
                return lengthEQ(getTranslation, 4, new InputType(0), value);
            }
            case "FIN": {
                return lengthEQ(getTranslation, 5, new InputType(0), value);
            }
            case "DNK": {
                return lengthEQ(getTranslation, 4, new InputType(0), value);
            }
            default: {
                return Result_Bind((str_2) => lengthLTE(getTranslation, 11, new InputType(0), str_2), lengthGT(getTranslation, 3, new InputType(0), value));
            }
        }
    }, isNotNullOrWhitespace(getTranslation, str));
    if (_arg.tag === 1) {
        return new FSharpResult$2(1, _arg.fields[0]);
    }
    else {
        return new FSharpResult$2(0, new ZipCode(0, _arg.fields[0]));
    }
}

export function ZipCodeModule_value(_arg) {
    return _arg.fields[0];
}

export class EInvoiceIdentifier extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["EInvoiceIdentifier"];
    }
}

export function EInvoiceIdentifier$reflection() {
    return union_type("Validation.Invoicee.EInvoiceIdentifier", [], EInvoiceIdentifier, () => [[["Item", option_type(string_type)]]]);
}

export function EInvoiceIdentifierModule_create(getTranslation, str) {
    if (str === "") {
        return new FSharpResult$2(0, new EInvoiceIdentifier(0, void 0));
    }
    else {
        const _arg = Result_Bind((str_2) => isOnlyNumbers(getTranslation, str_2), lengthEQ(getTranslation, 9, new InputType(0), str));
        if (_arg.tag === 1) {
            return new FSharpResult$2(1, _arg.fields[0]);
        }
        else {
            return new FSharpResult$2(0, new EInvoiceIdentifier(0, _arg.fields[0]));
        }
    }
}

export function EInvoiceIdentifierModule_createNonEmpty(getTranslation, str) {
    const _arg = Result_Bind((str_2) => isOnlyNumbers(getTranslation, str_2), lengthEQ(getTranslation, 9, new InputType(0), str));
    if (_arg.tag === 1) {
        return new FSharpResult$2(1, _arg.fields[0]);
    }
    else {
        return new FSharpResult$2(0, new EInvoiceIdentifier(0, _arg.fields[0]));
    }
}

export function EInvoiceIdentifierModule_value(_arg) {
    return _arg.fields[0];
}

export class InvoiceeNr extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["InvoiceeNr"];
    }
}

export function InvoiceeNr$reflection() {
    return union_type("Validation.Invoicee.InvoiceeNr", [], InvoiceeNr, () => [[["Item", string_type]]]);
}

export function InvoiceeNrModule_create(allowAddInvoiceeNr, getTranslation, str) {
    if (allowAddInvoiceeNr) {
        const _arg = Result_Bind((str_2) => isOnlyNumbers(getTranslation, str_2), lengthLTE(getTranslation, 10, new InputType(0), str));
        if (_arg.tag === 1) {
            return new FSharpResult$2(1, _arg.fields[0]);
        }
        else {
            return new FSharpResult$2(0, new InvoiceeNr(0, _arg.fields[0]));
        }
    }
    else {
        return new FSharpResult$2(0, new InvoiceeNr(0, str));
    }
}

export function InvoiceeNrModule_value(_arg) {
    return _arg.fields[0];
}

export const nameValidation = (getTranslation) => ((str) => String40Module_create(getTranslation, str));

export const orgNrValidation = (getTranslation) => ((isoCountryCode) => ((str) => OrganisationNumberModule_create(getTranslation, isoCountryCode, str)));

export const invoiceeNr = (allowAddInvoiceeNr) => ((getTranslation) => ((str) => InvoiceeNrModule_create(allowAddInvoiceeNr, getTranslation, str)));

export const customerGroupCodeValidation = (getTranslation) => ((str) => CustomerGroupCodeModule_create(getTranslation, str));

export const contactPersonValidation = (getTranslation) => ((str) => String32OrEmptyModule_create(getTranslation, str));

export const contactNumberValidation = (getTranslation) => ((str) => ContactNumberModule_create(getTranslation, str));

export const emailValidation = (getTranslation) => ((str) => EmailModule_create(getTranslation, str));

export const notEmptyEmailValidation = (getTranslation) => ((str) => EmailModule_createNonEmpty(getTranslation, str));

export const coValidation = (getTranslation) => ((str) => PostalAttentionModule_create(getTranslation, str));

export const addressValidation = (getTranslation) => ((str) => AlphaNumeric40Module_create(getTranslation, str));

export const zipCodeValidation = (getTranslation) => ((threeLetterCountryCode) => ((str) => ZipCodeModule_create(getTranslation, threeLetterCountryCode, str)));

export const cityValidation = (getTranslation) => ((str) => CityModule_create(getTranslation, str));

export const referenceValidation = (getTranslation) => ((str) => String32OrEmptyModule_create(getTranslation, str));

export const peppolIdValidation = (getTranslation) => ((str) => PeppolIdModule_create(getTranslation, str));

export const nonEmptyPeppolIdValidation = (getTranslation) => ((str) => PeppolIdModule_createNonEmpty(getTranslation, str));

export const ourReferenceValidation = (getTranslation) => ((str) => String32OrEmptyModule_create(getTranslation, str));

export const paymentTermsFixedDayValidation = (getTranslation) => ((str) => EmptyOrRange1To31Module_create(getTranslation, str));

export const eInvoiceIdentifierValidation = (getTranslation) => ((str) => EInvoiceIdentifierModule_createNonEmpty(getTranslation, str));

